import * as Sentry from '@sentry/react';
import React from 'react';
import {Redirect} from 'react-router-dom';
import resolvePath from '../../misc/resolvePath';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
        this.handleRouteChange = this.handleRouteChange.bind(this);
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    componentDidMount() {
        this.state.unlistenHistory = app.history.listen(this.handleRouteChange);
    }
    componentWillUnmount() {
        this.state.unlistenHistory();
    }

    componentDidCatch(error, errorInfo) {
        console.error(errorInfo);
        Sentry.captureException(error);
    }

    render() {
        if (this.state.hasError) {
            console.log('Render error boundary alternative');
            if (this.props.altComponent) {
                console.log('Alternative component: ', this.props.altComponent.type);
                return this.props.altComponent;
            } else if (this.props.altRoute) {
                console.log('Alternative route:', this.props.altRoute);
                if (this.props.altRoute.match(/^\./)) {
                    return <Redirect to={resolvePath(app.history.location.pathname, this.props.altRoute)} />;
                } else {
                    return <Redirect to={this.props.altRoute} />;
                }
            } else {
                return null;
            }
        }

        return this.props.children;
    }
    handleRouteChange() {
        if (this.state.hasError) {
            this.setState({hasError: false});
        }
    }
}
export default ErrorBoundary;
